import React from 'react'
import PropTypes from 'prop-types'
import Pager from 'components/Pager'
import AggChanelTable from './AggChanelsTable'

export default class AggChannelsList extends React.Component {
  static propTypes = {
    aggrStats: PropTypes.object,
    data: PropTypes.array,
    currentPage: PropTypes.number,
    maxPage: PropTypes.number,
    onPageChange: PropTypes.func,
    selectedGroups: PropTypes.object,
    filters: PropTypes.object,
    loading: PropTypes.bool
  }

  render() {
    const {
      aggrStats,
      data,
      loading,
      selectedGroups,
      filters
    } = this.props

    return (
      <div className='aggrs-filter_orders'>
        <div className='aggrs-filter_orders-table-wrapper'>
          <AggChanelTable
            aggrStats={aggrStats}
            data={data}
            loading={loading}
            selectedTouchpoints={selectedGroups}
            filters={filters}
          />
          {this.renderPaging()}
        </div>
      </div>
    )
  }

  renderPaging() {
    const {data, currentPage, maxPage} = this.props
    if (!data || !data.length || !maxPage) return null

    return (
      <div className='aggrs-filter_orders-table-pager'>
        <Pager
          className='container'
          page={currentPage + 1}
          max={maxPage}
          onPageSelect={this.onPageSelect}
        />
      </div>
    )
  }

  onPageSelect = page => {
    this.props.onPageChange(page - 1)
  }
}



// WEBPACK FOOTER //
// ./client/views/AggreatedAttributionView/AggChannelsList.js